// extracted by mini-css-extract-plugin
export default {"scroll-offset":"styles_scroll-offset__cb2kX"};